import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceHistoryToolPanel extends Layout {
    buttonReprintBalanceDue: Button;
    buttonReprintMiscBill: Button;
    panelButtons: Panel;
    panelToolLeft: Panel;
    panelToolRight: Panel;
}
